import { useQuery } from "@tanstack/react-query";
import { getDiscountClients } from "../api/discounts";
import { getRestaurantName } from "../lib/restaurant";

export const useDiscountClients = (enabled = true) => {
  return useQuery({
    queryKey: ["discounts", "clients"],
    queryFn: () => getDiscountClients(getRestaurantName()),
    enabled,
    staleTime: 1000 * 60 * 5, // 5 min
  });
};
